// extracted by mini-css-extract-plugin
export default {"content":"SocietyCart_content__1yF4h","realContent":"SocietyCart_realContent__8TxST"};